import React, { Component } from 'react'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'

import * as Constants from '../../helpers/Constants'

class IconButton extends Component {
  state = {
    hover: false
  }

  render() {
    const { hover } = this.state
    const {
      onClick,
      icon,
      color = Constants.WHITE_LABEL.colors.primary,
      hoverColor = Constants.WHITE_LABEL.colors.primaryHover,
      style,
      iconStyle
    } = this.props

    return (
      <a
        onMouseEnter={() => this.setState({ hover: true })}
        onMouseLeave={() => this.setState({ hover: false })}
        onClick={() => onClick()}
        style={{ backgroundColor: 'transparent', ...style }}
      >
        {
          <FontAwesomeIcon
            icon={icon}
            style={{
              fontSize: 26,
              color: hover ? hoverColor : color,
              ...iconStyle
            }}
          />
        }
      </a>
    )
  }
}

export { IconButton }



// WEBPACK FOOTER //
// ./src/components/kevinsLegacy/IconButton.js